import nft_1 from "./assets/img/nft-1.png";
import nft_2 from "./assets/img/nft-2.png";
import nft_3 from "./assets/img/nft-3.png";
import nft_4 from "./assets/img/nft-4.png";
import nft_5 from "./assets/img/nft-5.png";
import nft_6 from "./assets/img/nft-6.png";
import nft_7 from "./assets/img/nft-7.png";
import nft_8 from "./assets/img/nft-8.png";
import nft_9 from "./assets/img/nft-9.png";
import nft_10 from "./assets/img/nft-10.png";
import nft_11 from "./assets/img/nft-11.png";
import nft_12 from "./assets/img/nft-12.png";
import nft_13 from "./assets/img/nft-13.png";
import nft_14 from "./assets/img/nft-14.png";
import nft_15 from "./assets/img/nft-15.png";
import nft_16 from "./assets/img/nft-16.png";

export const placeToStay = [
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_5,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_6,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_7,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_8,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_1,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_2,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_3,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_4,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_9,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_10,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_11,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_12,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_13,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_14,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_15,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_16,
      alt: "an nft",
    },
  },
];

export const home = [
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_1,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_2,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_3,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_4,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_5,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_6,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_7,
      alt: "an nft",
    },
  },
  {
    name: "Desert King",
    price: {
      value: 1,
      unit: "MBT",
    },
    distance: {
      value: 2345,
      unit: "km",
    },
    rating: 5,
    availability: {
      value: 2,
      unit: "weeks",
    },
    img: {
      src: nft_8,
      alt: "an nft",
    },
  },
];

// export { placeToStay, home };
